import React, { useRef, useState } from 'react'
import { useTrans } from '@next-nx/hooks'
import { ChevronDown, ChevronUp } from '@next-nx/shared-ui/icons'
import { WContainer, Button } from '@next-nx/shared-ui/atoms'
import styles from './ListingSeoText.module.sass'


interface Props {
  text: string
  className?: string
}

const ListingSeoText = (props: Props) => {

  const { 
    text = '',
    className = '',
  } = props

  const t = useTrans()
  const [open, setOpen] = useState(false)
  const innerContentRef = useRef(null)

  return (
    <div className={`${styles.root} ${className}`}>
      <WContainer>
        <div className={styles.layout}>
          <div 
            className={styles.content}
            style={{
              maxHeight: innerContentRef?.current && open ? innerContentRef.current.clientHeight : undefined,
            }}
          >
            <div className={styles.innerContent} dangerouslySetInnerHTML={{ __html: text }} ref={innerContentRef} />
          </div>
          <Button 
            label={t(open ? "Chiudi" : "Leggi di più")} 
            icon={open ? <ChevronUp /> : <ChevronDown />} 
            iconPos="right"
            variant='ghost'
            color="blue"
            className={styles.cta} 
            onClick={() => setOpen(!open)}
          />
        </div>
      </WContainer>
    </div>
  )
}

export default ListingSeoText
